import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ContactoFlotanteComponent } from './contacto-flotante/contacto-flotante.component';
import { ContactoEstaticoComponent } from './contacto-estatico/contacto-estatico.component';

@NgModule({
  declarations: [
    ContactoFlotanteComponent,
    ContactoEstaticoComponent
  ],
  imports: [
    // BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    ContactoFlotanteComponent,
    ContactoEstaticoComponent
  ]
})
export class ContactoModule { }
